import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addSubscription, addTutor, approveRejectTutor, blockUnblockTutor, deleteTutor, editTutor, tutorListing, viewTutor } from "../apis/apiHandler";

export const allTutors = createAsyncThunk(
    'tutor/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await tutorListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const addTutors = createAsyncThunk(
    'tutor/add',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await addTutor(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const editTutors = createAsyncThunk(
    'tutor/edit',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await editTutor(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewTutorDetail = createAsyncThunk(
    'tutor/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewTutor(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const deleteTutors = createAsyncThunk(
    'tutor/delete',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteTutor(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const assignSubscription = createAsyncThunk(
    'tutor/add-subscription',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await addSubscription(payload);

            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const changeTutorStatus = createAsyncThunk(
    'tutor/status',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await blockUnblockTutor(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const approveRejectTutors = createAsyncThunk(
    'tutor/approve',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await approveRejectTutor(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    tutorList: [],
    error: null,
    addSuccess: false,
    editSuccess: false,
    tutorDetail: {},
    deleteSuccess: false,
    subscriptionSuccess: false,
    statusSuccess: false,
    approveSuccess: false,
};

const tutorSlice = createSlice({
    name: 'tutor',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(allTutors.pending, (state) => {
                state.loading = true;
            })
            .addCase(allTutors.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.tutorList = payload?.data;
            })
            .addCase(allTutors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(addTutors.pending, (state) => {
                state.loading = true;
                state.addSuccess = false;
                state.error = null;
            })
            .addCase(addTutors.fulfilled, (state) => {
                state.loading = false;
                state.addSuccess = true;
            })
            .addCase(addTutors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.addSuccess = false;
            })
            .addCase(editTutors.pending, (state) => {
                state.loading = true;
                state.editSuccess = false;
                state.error = null;
            })
            .addCase(editTutors.fulfilled, (state) => {
                state.loading = false;
                state.editSuccess = true;
            })
            .addCase(editTutors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.editSuccess = false;
            })
            .addCase(viewTutorDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewTutorDetail.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.tutorDetail = payload?.data;
            })
            .addCase(viewTutorDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteTutors.pending, (state) => {
                state.loading = true;
                state.deleteSuccess = false;
                state.error = null;
            })
            .addCase(deleteTutors.fulfilled, (state) => {
                state.loading = false;
                state.deleteSuccess = true;
            })
            .addCase(deleteTutors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.deleteSuccess = false;
            })
            .addCase(changeTutorStatus.pending, (state) => {
                state.loading = true;
                state.statusSuccess = false;
                state.error = null;
            })
            .addCase(changeTutorStatus.fulfilled, (state) => {
                state.loading = false;
                state.statusSuccess = true;
            })
            .addCase(changeTutorStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.statusSuccess = false;
            })
            .addCase(approveRejectTutors.pending, (state) => {
                state.loading = true;
                state.approveSuccess = false;
                state.error = null;
            })
            .addCase(approveRejectTutors.fulfilled, (state) => {
                state.loading = false;
                state.approveSuccess = true;
            })
            .addCase(approveRejectTutors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.approveSuccess = false;
            })
            .addCase(assignSubscription.pending, (state) => {
                state.loading = true;
                state.subscriptionSuccess = false;
                state.error = null;
            })
            .addCase(assignSubscription.fulfilled, (state) => {
                state.loading = false;
                state.subscriptionSuccess = true;
            })
            .addCase(assignSubscription.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.subscriptionSuccess = false;
            })
    }
})

export default tutorSlice.reducer;